// filepath: /c:/Users/Tyl2002/OneDrive/OneDrive - Swinburne University/Desktop/Data's Tylor/Projects/Wheretospot/my-react-app/src/styles/GlobalStyles.ts
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --black: rgba(0, 0, 0, 1);
    --branding-1: rgba(2, 104, 219, 1);
    --branding-2: rgba(4, 80, 135, 1);
    --branding-3: rgba(3, 22, 44, 1);
    --content-text-bold-font-family: "Microsoft PhagsPa", Helvetica;
    --content-text-bold-font-size: 16px;
    --content-text-bold-font-style: normal;
    --content-text-bold-font-weight: 700;
    --content-text-bold-letter-spacing: 0.30000001192092896px;
    --content-text-bold-line-height: 22px;
    --content-text-normal-font-family: "Microsoft PhagsPa", Helvetica;
    --content-text-normal-font-size: 16px;
    --content-text-normal-font-style: normal;
    --content-text-normal-font-weight: 400;
    --content-text-normal-letter-spacing: 0.30000001192092896px;
    --content-text-normal-line-height: 22px;
    --dark-grey: rgba(93, 93, 94, 1);
    --grey: rgba(153, 153, 153, 1);
    --h1-desk-tabl-font-family: "Microsoft PhagsPa", Helvetica;
    --h1-desk-tabl-font-size: 64px;
    --h1-desk-tabl-font-style: normal;
    --h1-desk-tabl-font-weight: 700;
    --h1-desk-tabl-letter-spacing: 0.20000000298023224px;
    --h1-desk-tabl-line-height: 56px;
    --h1-mobile-font-family: "Microsoft PhagsPa", Helvetica;
    --h1-mobile-font-size: 48px;
    --h1-mobile-font-style: normal;
    --h1-mobile-font-weight: 700;
    --h1-mobile-letter-spacing: 0.20000000298023224px;
    --h1-mobile-line-height: 56px;
    --h2-font-family: "Microsoft PhagsPa", Helvetica;
    --h2-font-size: 32px;
    --h2-font-style: normal;
    --h2-font-weight: 700;
    --h2-letter-spacing: 0.10000000149011612px;
    --h2-line-height: 40px;
    --h3-font-family: "Microsoft PhagsPa", Helvetica;
    --h3-font-size: 18px;
    --h3-font-style: normal;
    --h3-font-weight: 700;
    --h3-letter-spacing: 0.10000000149011612px;
    --h3-line-height: 20px;
    --light-black: rgb(20 20 26);
    --light-grey: rgba(211, 211, 211, 1);
    --messages-benefit: rgba(242, 232, 46, 1);
    --messages-whatsapp: rgba(18, 207, 32, 1);
    --navigated-text-bold-font-family: "Microsoft PhagsPa", Helvetica;
    --navigated-text-bold-font-size: 14px;
    --navigated-text-bold-font-style: normal;
    --navigated-text-bold-font-weight: 700;
    --navigated-text-bold-letter-spacing: 0.20000000298023224px;
    --navigated-text-bold-line-height: 18px;
    --navigated-text-normal-font-family: "Microsoft PhagsPa", Helvetica;
    --navigated-text-normal-font-size: 14px;
    --navigated-text-normal-font-style: normal;
    --navigated-text-normal-font-weight: 400;
    --navigated-text-normal-letter-spacing: 0.20000000298023224px;
    --navigated-text-normal-line-height: 18px;
    --slogan-desktop-tablet-font-family: "Microsoft PhagsPa", Helvetica;
    --slogan-desktop-tablet-font-size: 44px;
    --slogan-desktop-tablet-font-style: normal;
    --slogan-desktop-tablet-font-weight: 400;
    --slogan-desktop-tablet-letter-spacing: 5px;
    --slogan-desktop-tablet-line-height: 71px;
    --slogan-mobile-font-family: "Microsoft PhagsPa", Helvetica;
    --slogan-mobile-font-size: 24px;
    --slogan-mobile-font-style: normal;
    --slogan-mobile-font-weight: 400;
    --slogan-mobile-letter-spacing: 5px;
    --slogan-mobile-line-height: 48px;
    --small-text-bold-font-family: "Microsoft PhagsPa", Helvetica;
    --small-text-bold-font-size: 12px;
    --small-text-bold-font-style: normal;
    --small-text-bold-font-weight: 700;
    --small-text-bold-letter-spacing: 0.20000000298023224px;
    --small-text-bold-line-height: 16px;
    --small-text-normal-font-family: "Microsoft PhagsPa", Helvetica;
    --small-text-normal-font-size: 12px;
    --small-text-normal-font-style: normal;
    --small-text-normal-font-weight: 400;
    --small-text-normal-letter-spacing: 0.20000000298023224px;
    --small-text-normal-line-height: 16px;
    --white: rgba(255, 255, 255, 1);
    --spacing-8: 8px;
    --spacing-16: 16px; 
    --spacing-24: 24px;
    --spacing-32: 32px;
    --spacing-40: 40px;
    --spacing-48: 48px;
    --spacing-56: 56px;
    --spacing-64: 64px;
    --spacing-72: 72px;
    --spacing-80: 80px;
    --spacing-88: 88px;
    --spacing-96: 96px;
    --spacing-104: 104px;
    --spacing-112: 112px;
    --spacing-120: 120px;
    --transition-default: filter 0.3s ease;
    --hover-effect: brightness(0.75);
    --hover-effect-for-navigation: brightness(2);
    --active-effect: brightness(0.65);
    --active-effect-for-navigation: brightness(2.5);
  }
`;

export default GlobalStyles;